/**
 * Paths that require manual handling (entry shares, partner links) rather than
 * being handled directly by React Navigation's linking system.
 */
export const requiresManualWebHandling = (path: string): boolean => {
    return path.includes('entry/') || path.includes('/referral');
};

export const isPicksSpecificUrl = (url?: string | null) => {
    return url?.startsWith('picks') || url?.startsWith('/picks') || url?.includes('/entry');
};

export const isArcadeSpecificUrl = (url?: string | null) => {
    return url?.startsWith('arcade') || url?.startsWith('/arcade');
};

export const isCasinoSpecificUrl = (url?: string | null) => {
    return url?.startsWith('casino') || url?.startsWith('/casino');
};

export const isSweepsSpecificUrl = (url?: string | null) => {
    return url?.startsWith('social') || url?.startsWith('/social');
};

export const isPredictionSpecificUrl = (url?: string | null) => {
    return url?.startsWith('prediction') || url?.startsWith('/prediction');
};

export const isRipsSpecificUrl = (url?: string | null) => {
    return url?.startsWith('rips') || url?.startsWith('/rips');
};

export const cleanDeepLinkPath = (path: string): string => {
    return path.replace(/^\/+/, '').replace(/\?.*$/, '');
};
